package settings.diagnosisSetting.containers


import com.jingfangpai.api.clients.DiagnosisSettingApiClient
import com.jingfangpai.api.clients.SignSymptomApiClient
import com.jingfangpai.diagnosisSetting.model.DiagnosisSettings
import react.*
import react.dom.div
import setTitle
import settings.diagnosisSetting.components.DiagnosisSettingComponent
import user.service.AuthService

external interface DiagnosisSettingPageProps : RProps {

}

data class SignSymptomSettingPageContextData(
    var getCurrentUserAvailable:(userId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<DiagnosisSettings>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit,
    var saveDiagnosisSetting:(form:com.jingfangpai.common.orm.mapping.DiagnosisSetting, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.DiagnosisSetting>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getSignSymptomOptions: ( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.data.model.CascadedOption<kotlin.String>>>) -> Unit, errorCallback: (exception:Throwable) -> Unit) ->Unit
)

val DiagnosisSettingPageContext = createContext(SignSymptomSettingPageContextData(DiagnosisSettingApiClient::getCurrentUserAvailable,DiagnosisSettingApiClient::save,SignSymptomApiClient::getOptions))

val DiagnosisSettingPageProvider = functionalComponent<DiagnosisSettingPageProps> { props ->

    setTitle("诊查设置")

    fun placeHolderFunction(param: String) {
        console.log("doing something with param")
    }

    useEffectOnce {

    }

    DiagnosisSettingPageContext.Provider(SignSymptomSettingPageContextData(DiagnosisSettingApiClient::getCurrentUserAvailable,DiagnosisSettingApiClient::save,SignSymptomApiClient::getOptions)) {
        div("SignSymptomSettingPage-page") {
            child(DiagnosisSettingComponent) {
                attrs{
                    currentUserId = AuthService.getUserAuthData()?.id?:""
                }
            }
        }
    }
}
